import http from './api'

const route = 'app/comercial/analisemargem/'

export default {
  showAnaliseMargemFaturamento: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseMargemFaturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseMargemGrupoProdutos: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseMargemGrupoProdutos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseMargemRepresentante: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseMargemRepresentante', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseMargemCliente: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseMargemCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseMargemRede: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseMargemRede', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },
}
